import React from 'react';
import { motion } from 'framer-motion';
import { FiInfo, FiGithub, FiGlobe, FiTwitter } from 'react-icons/fi';
import Header from './Header';
import '../styles/AboutPage.css';

const AboutPage = () => {
  const socialLinks = [
    {
      icon: FiGlobe,
      title: 'Website',
      description: 'Visit our official website',
      link: 'https://ton.org'
    },
    {
      icon: FiGithub,
      title: 'GitHub',
      description: 'View source code and contribute',
      link: 'https://github.com/ton-blockchain'
    },
    {
      icon: FiTwitter,
      title: 'Twitter',
      description: 'Follow us for updates',
      link: 'https://twitter.com/ton_blockchain'
    }
  ];

  return (
    <div className="about-page">
      <Header title="About" className="sticky-header" />

      <div className="about-content">
        <motion.div
          className="about-card"
          initial={{ scale: 0.95, opacity: 0, y: 20 }}
          animate={{ scale: 1, opacity: 1, y: 0 }}
          transition={{ duration: 0.4, ease: "easeOut" }}
        >
          <div className="about-header">
            <motion.div
              className="header-icon"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{ delay: 0.2, type: "spring" }}
            >
              <FiInfo />
            </motion.div>
            <h2>DexWallet</h2>
            <p>v1.0.0 • BETA</p>
          </div>

          <div className="about-section">
            <motion.h3
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.3 }}
            >
              About This Wallet
            </motion.h3>
            <p className="about-description">
              A secure, non-custodial multi-chain wallet designed for the future of finance.
              Manage your TON and BNB assets with military-grade encryption and an intuitive glass interface.
            </p>
          </div>

          <div className="features-section">
            <motion.h3
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4 }}
            >
              Key Features
            </motion.h3>
            <ul className="features-list">
              <motion.li whileHover={{ x: 5 }}>Multi-chain support for TON & BNB</motion.li>
              <motion.li whileHover={{ x: 5 }}>Unified 12-word recovery phrase</motion.li>
              <motion.li whileHover={{ x: 5 }}>Zero-knowledge architecture</motion.li>
              <motion.li whileHover={{ x: 5 }}>Real-time stealth transactions</motion.li>
            </ul>
          </div>

          <div className="links-section">
            <motion.h3
              initial={{ opacity: 0, x: -10 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.5 }}
            >
              Connect With Us
            </motion.h3>
            <div className="social-links">
              {socialLinks.map((link, index) => {
                const Icon = link.icon;
                return (
                  <motion.a
                    key={index}
                    href={link.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="social-link"
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.6 + (index * 0.1) }}
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    <div className="link-content">
                      <div className="link-icon">
                        <Icon />
                      </div>
                      <div className="link-text">
                        <span className="link-title">{link.title}</span>
                        <span className="link-description">{link.description}</span>
                      </div>
                    </div>
                  </motion.a>
                );
              })}
            </div>
          </div>

          <div className="developer-section">
            <h3>Developer & Support</h3>
            <div className="developer-info">
              <span className="dev-name">Masanidev</span>
              <motion.a
                href="mailto:masanideveloper@gmail.com?subject=Bug%20Report%20-%20DexWallet"
                className="report-bug-btn"
                target="_blank"
                rel="noopener noreferrer"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Report a Bug
              </motion.a>
            </div>
          </div>

          <div className="credits-section">
            <p className="credits-text">
              © 2024 DexWallet. Built with ❤️ for the crypto community.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default AboutPage; 